import React, { Component } from "react";
import { withRouter } from "react-router";
import { GetWARPUrl } from "../../config";


let messageData = "";
let startPageKey = "";

class Questionnaire extends Component {
constructor(props) {
    super(props);
    this.state = {
      loading: false,
      iframeHeight: 720,
    };
  }

  

   handleMessage = async (event) => {
      event.preventDefault();
      event.preventDefault();
      let dataType = typeof event.data;
      if (dataType === "string") {
        try {
          messageData = JSON.parse(event.data);
          const type = messageData.type;
          switch (type) {
            case "warp-content-resize":
              if (
                this.state.iframeHeight !== messageData.data.height
              ) {
                const newHeight = Math.min(
                  Math.max(messageData.data.height + 50, 500), // Minimum 500px
                  window.innerHeight * 0.9 // Maximum 90% of viewport height
                );
                this.setState({ iframeHeight: messageData.data.height + 70 });
              }
              break;
            case "warp-invitation-form-start":
              debugger;
              const invitationId_start = messageData.data.invitationId;
              
              let AssessmentFormName = messageData.data.questionId;
              let comapnyName = "Test Company";
              
                window.open(`/AssessmentIntroDetails/scoring_test/${invitationId_start}/intro?assessmentname=${AssessmentFormName}&companyname=${comapnyName}`, '_blank');
              break;

            default:
              break;
          }
        } catch (error) {}
      }
    };

    componentDidMount() {
      window.addEventListener("message", this.receiveMessage, false);
      this.setState({ loading: true }); 

      window.addEventListener("popstate", this.handlePopState);
    window.addEventListener("message", this.handleMessage);
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", this.handlePopState);
        window.removeEventListener("message", this.handleMessage);
        this.props.QueryButtonShow(false);
      }


    render() {

        return (
            <iframe
            title="Questionnaire"
            src={GetWARPUrl() + "questionnaires?accessToken=" + (localStorage.getItem("warpToken") || "")}
            width="100%"
            height={this.state.iframeHeight}
            style={{ border: "none" }}
            >
          </iframe>
        );
    }
}
   


export default withRouter(
  (Questionnaire)
);